import PESService from 'App/services/PESService';
import { useQuery } from 'react-query';
import { errorHandler } from 'App/utils';

function useFetchWorkQueueSavedFilters(filterType) {
    return useQuery(['workQueue', 'savedFilters', filterType], () => PESService.getFilters(filterType), {
        onError: errorHandler,
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });
}
export default useFetchWorkQueueSavedFilters;
